import { createSaveTableSettingsEpic } from '../../../common/datagrid';
import { notifyProductUpdated } from '../../../common/signalr/signalrActions';
import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { enqueueSnackbar } from '../../ui/redux/uiSlices';
import {
    createProduct,
    createProductCategory,
    createProductGroup,
    deleteProduct,
    deleteProductCategory,
    deleteProductGroup,
    fetchProductCategories,
    fetchProductGroups,
    fetchProducts,
    productTableActions,
    showCreateProductDialog,
    updateProduct,
    updateProductCategory,
    updateProductGroup
} from './productSlices';

const fetchProducts$ = createEpicFromAsyncActionEmptyRequest(fetchProducts, ({ productClient }) =>
    productClient.getAllActive()
);

const fetchProductCategories$ = createEpicFromAsyncActionEmptyRequest(
    fetchProductCategories,
    ({ productCategoryClient }) => productCategoryClient.getAll()
);
const createProductCategory$ = createEpicFromAsyncAction(
    createProductCategory,
    (req, { productCategoryClient }) => productCategoryClient.create(req)
);
const deleteProductCategory$ = createEpicFromAsyncAction(
    deleteProductCategory,
    (req, { productCategoryClient }) => productCategoryClient.delete(req).then(() => req)
);
const updateProductCategory$ = createEpicFromAsyncAction(
    updateProductCategory,
    (req, { productCategoryClient }) =>
        productCategoryClient.update(req.productCategoryId, req).then(() => req)
);

const createProductGroup$ = createEpicFromAsyncAction(createProductGroup, (req, { productGroupClient }) =>
    productGroupClient.create(req)
);

const fetchProductGroups$ = createEpicFromAsyncActionEmptyRequest(
    fetchProductGroups,
    ({ productGroupClient }) => productGroupClient.getAll()
);
const updateProductGroup$ = createEpicFromAsyncAction(updateProductGroup, (req, { productGroupClient }) =>
    productGroupClient.update(req).then(() => req)
);

const deleteProductGroup$ = createEpicFromAsyncAction(deleteProductGroup, (req, { productGroupClient }) =>
    productGroupClient.delete(req).then(() => req)
);

const saveProductTable$ = createSaveTableSettingsEpic(productTableActions, state => state.product.table);

const updateProduct$ = createEpicFromAsyncAction(
    updateProduct,
    (req, { productClient }) => productClient.updateProduct(req.productId, req.dto).then(() => req),
    req => notifyProductUpdated(req.productId)
);

const createProduct$ = createEpicFromAsyncAction(
    createProduct,
    (request, { productClient }) =>
        productClient.create(request).then(productId => ({
            ...request,
            productId: productId,
            hidePrices: false
        })),
    () => [
        showCreateProductDialog(false),
        enqueueSnackbar({
            message: 'Product created',
            severity: 'success',
            autoHideDuration: 3000
        })
    ],
    (req, message) =>
        enqueueSnackbar({
            message: "Couldn't create product: " + message,
            severity: 'error',
            autoHideDuration: 3000
        })
);

const deleteProduct$ = createEpicFromAsyncAction(
    deleteProduct,
    (request, { productClient }) => productClient.delete(request).then(() => request),
    () =>
        enqueueSnackbar({
            message: 'Product deleted',
            severity: 'success',
            autoHideDuration: 3000
        })
);

export default [
    fetchProducts$,
    fetchProductCategories$,
    fetchProductGroups$,
    saveProductTable$,
    updateProduct$,
    createProduct$,
    createProductCategory$,
    createProductGroup$,
    updateProductCategory$,
    updateProductGroup$,
    deleteProductCategory$,
    deleteProductGroup$,
    deleteProduct$
];
